import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { replacePathParams } from 'utils/routes.utils';

import { Routes } from 'constants/routes.constants';
import { EnhancedTicketsEventCard } from 'types/tickets.types';

import EventTicketsContent from 'components/@account/EventTicketsContent';
import BorderStack from 'components/@common/BorderStack';
import LinkUnstyled from 'components/@common/LinkUnstyled';
import EventListItem from 'components/@events/EventListItem';
import { isEventToday } from 'components/@events/utils';

interface Props {
  event: EnhancedTicketsEventCard;
  hasBorder?: boolean;
}

const CurrentEvent = ({ event }: { event: EnhancedTicketsEventCard }) => {
  return (
    <BorderStack
      href={replacePathParams(Routes.AccountTicketsDetail, {
        slug: event.slug,
      })}
      component={LinkUnstyled}
      sx={{ gap: 2 }}
    >
      <EventListItem>
        <EventTicketsContent
          cover={event.cover}
          title={event.title}
          startDatetime={event.startDatetime}
          endDatetime={event.endDatetime}
          timezone={event.timezone}
          city={event.venue.city.name}
          quantity={event.ticketCount}
        />
      </EventListItem>

      <Button variant="outlined" color="secondary">
        <FormattedMessage id="tickets.show.tickets.button" />
      </Button>
    </BorderStack>
  );
};

const FutureEvent = ({ event }: { event: EnhancedTicketsEventCard }) => {
  return (
    <EventListItem
      component={LinkUnstyled}
      href={replacePathParams(Routes.AccountTicketsDetail, {
        slug: event.slug,
      })}
    >
      <EventTicketsContent
        cover={event.cover}
        title={event.title}
        startDatetime={event.startDatetime}
        endDatetime={event.endDatetime}
        timezone={event.timezone}
        city={event.venue.city.name}
        quantity={event.ticketCount}
      />
    </EventListItem>
  );
};

const UpcomingEventItem = ({ event, hasBorder }: Props) => {
  const isCurrent = isEventToday(event);

  if (isCurrent) return <CurrentEvent key={event.id} event={event} />;

  if (hasBorder)
    return (
      <BorderStack>
        <FutureEvent key={event.id} event={event} />
      </BorderStack>
    );

  return <FutureEvent key={event.id} event={event} />;
};

export default UpcomingEventItem;
